import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import history from 'history/browser';
import { FormattedMessage, useIntl } from 'react-intl';
import * as Styled from './styled';

function DismissableWarning({
  onWarningDismissed,
  helpLink,
  timeout,
  copySection,
}) {
  const intl = useIntl();

  useEffect(() => {
    const removeListener = history.listen(() => {
      onWarningDismissed();
    });

    return () => {
      removeListener();
    };
  }, [onWarningDismissed]);

  // closes the warning dialog after 'timeout' milliseconds
  if (Number.isFinite(timeout)) {
    setTimeout(onWarningDismissed, timeout);
  }

  return (
    <Styled.DismissableWarningBackground>
      <Styled.DismissableWarningClose onClick={onWarningDismissed}>
        <Styled.DismissableWarningCloseIcon />
      </Styled.DismissableWarningClose>
      <Styled.DismissableWarningMainRow>
        <Styled.DismissableWarningContent>
          <Styled.TrimetIcon />
          <Styled.DismissableWarningMessage>
            <FormattedMessage id={`${copySection}.warning`} />
            {helpLink && (
              <>
                {' '}
                <Styled.DismissableWarningMessageEmphasis
                  href={helpLink}
                  rel="noopener"
                  target="_blank"
                  label={intl.formatMessage({
                    id: `${copySection}.warningemphasis_acc`,
                  })}
                >
                  <FormattedMessage id={`${copySection}.warningemphasis`} />
                </Styled.DismissableWarningMessageEmphasis>
              </>
            )}
          </Styled.DismissableWarningMessage>
          <Styled.DismissableWarningDismiss onClick={onWarningDismissed}>
            <FormattedMessage id={`${copySection}.warningdismiss`} />
          </Styled.DismissableWarningDismiss>
        </Styled.DismissableWarningContent>
      </Styled.DismissableWarningMainRow>
    </Styled.DismissableWarningBackground>
  );
}

DismissableWarning.propTypes = {
  /** URL for an independent help site */
  helpLink: PropTypes.string,
  /** timeout (ms) for warning to magically close (default 7.5 seconds - null == no timeout) */
  timeout: PropTypes.number,
  /** Key to section in intl json file that contains copy for the error */
  copySection: PropTypes.string.isRequired,
  /** Callback that is invoked when the warning is dismissed */
  onWarningDismissed: PropTypes.func.isRequired,
};

DismissableWarning.defaultProps = {
  helpLink: null,
  timeout: 3000,
};

export default DismissableWarning;
